import constant from "../constant";

const initState = {
  baseInfo: {
    uid: null,
    name: '',
    desc: ''
  },
  progress: {
    value: 0.3,
    loading: true,
    current: {
      chapterId: '',
      chapterNo: '',
      lessonId: '',
      lessonNo: '',
      subtitle: ''
    }
  },
  courseInfos: [],
  activeIndexCourseIndex: window.localStorage.getItem('active-course-index') || 0,
  catalogs: [
    // {
    //   chapterName: '第一章：Python语法课',
    //   chapterId: '1',
    //   chapterDesc: '本章从Python语法开始学习并完成一个售卖系统的开发',
    //   expand: false,
    //   lessons: [
    //     {
    //       title: '1. Python欢迎你',
    //       label: 'welcome',
    //       id: '1',
    //       finished: true
    //     },
    //     {
    //       title: '2. 代码注释',
    //       label: 'comment',
    //       id: '2',
    //       finished: false
    //     },
    //     {
    //       title: '3. Print输出',
    //       label: 'print',
    //       id: '3',
    //       finished: false
    //     }
    //   ]
    // },
    // {
    //   chapterName: '第二章：函数和方法',
    //   chapterId: '2',
    //   chapterDesc: '本章学习函数，学习如何将重复的代码进行复用，并将本章所学的知识用于解决一些物理上的问题',
    //   expand: false,
    //   lessons: [
    //     {
    //       title: '1. 什么是函数？',
    //       label: 'function',
    //       id: '1',
    //       finished: false
    //     },
    //     {
    //       title: '2. 如何使用函数',
    //       label: 'invoke function',
    //       id: '2',
    //       finished: false
    //     }
    //   ]
    // }
  ],
  learnInfo: {
    loading: false,
    learnAllHours: '',
    last7Days: [],
    severalLearnDays: 0,
    heatmapData: []
  }
};

export default (state = initState, action) => {
  switch (action.type) {
    case constant.courseEntry.SET_PROGRESS:
      return {
        ...state,
        progress: action.payload
      };
    case constant.courseEntry.EXPAND_CATALOG:
      if (state.catalogs[action.payload]) {
        state.catalogs[action.payload].expand = !state.catalogs[action.payload].expand;
      }
      return {
        ...state,
        catalogs: [...state.catalogs]
      };
    case constant.courseEntry.SET_CATALOGS:
      return {
        ...state,
        catalogs: action.payload
      };
    case constant.courseEntry.SET_BASE_INFO:
      return {
        ...state,
        baseInfo: action.payload
      };
    case constant.courseEntry.SET_LEARN_INFO:
      return {
        ...state,
        learnInfo: {
          ...state.learnInfo,
          ...action.payload
        }
      };
    case constant.courseEntry.SET_COURSE_INFOS:
      return {
        ...state,
        courseInfos: action.payload
      };
    case constant.courseEntry.SET_ACTIVE_COURSE_INDEX:
      return {
        ...state,
        activeIndexCourseIndex: action.payload
      };
    default:
      return state;
  }
}
